<template>
  <div class="image-label">
    <!-- 工具栏 -->
    <el-radio-group
      v-model="drawMode"
      size="large"
      fill="#409eff"
      @change="onSetMode"
      style="margin:8px 0"
    >
      <el-radio-button label="PAN">
        <el-tooltip content="鼠标" placement="top">
          <i class="el-icon-mouse"></i>
        </el-tooltip>
      </el-radio-button>
      <el-radio-button label="RECT" v-if="labelValue">
        <el-tooltip content="框选目标" placement="top">
          <i class="el-icon-edit"></i>
        </el-tooltip>
      </el-radio-button>
    </el-radio-group>
    <!-- 标注容器 -->
    <div
      id="AILabel-container"
      v-loading="loading"
      element-loading-text="加载中..."
      element-loading-background="rgba(0,0,0,.1)"
    >
      <el-popover
        v-model="popoverVisible"
        :virtual-ref="$refs.popoverRef"
        virtual-triggering
        trigger="manual"
        placement="right-start"
        width="140"
        :show-arrow="false"
      >
        <div class="menu-item danger" @click="deleteLabel">
          删除
        </div>
        <div
          ref="popoverRef"
          class="popover-anchor"
          slot="reference"
          :style="{ left: menuX + 'px', top: menuY + 'px' }"
        ></div>
      </el-popover>

      <!-- 右键菜单 -->
    </div>
  </div>
</template>
<script>
import AILabel from "ailabel";
import { Message } from "element-ui";

export default {
  name: "AILabelRect",

  props: {
    value: {
      required: true
    },
    fileUrl: {
      type: String,
      required: true
    },
    labelValue: {
      type: Object,
      required: false
    },
    labelOptions: {
      required: false
    }
  },

  data() {
    return {
      drawMode: "PAN",
      loading: false,

      ailabel: null,
      imageLayer: null,
      featureLayer: null,
      textLayer: null,

      imageW: 0,
      imageH: 0,
      imageBlob: "",

      labelList: [],

      // 右键菜单
      popoverVisible: false,
      menuX: 0,
      menuY: 0,
      clickRegion: null
    };
  },
  watch: {
    fileUrl: {
      immediate: true,
      handler(val) {
        if (val) {
          this.loadImage();
        }
      }
    },
    labelOptions: {
      immediate: true,
      deep: true,
      handler(val) {
        console.log();
        const ids = val.map(i => i.label);
        console.log(ids);
        this.labelList.forEach(item => {
          console.log(item.props.label);
          if (!ids.includes(item.props.label)) {
            this.featureLayer.removeFeatureById(item.id);
            this.textLayer.removeTextById(item.id);
          }
        });
        this.labelList = this.labelList.filter(i =>
          ids.includes(i.props.label)
        );
        this.$emit("input", this.labelList);
      }
    }
  },
  mounted() {
    // this.loadImage();
  },

  methods: {
    /** 加载图片 */
    async loadImage() {
      const res = await fetch(this.fileUrl);
      const blob = await res.blob();
      this.imageBlob = URL.createObjectURL(blob);

      const img = new Image();
      img.onload = () => {
        this.imageW = img.width;
        this.imageH = img.height;
        this.initAILabel();
      };
      img.src = this.imageBlob;
    },

    /** 初始化 AILabel */
    initAILabel() {
      const container = document.getElementById("AILabel-container");
      const cw = container.clientWidth;
      const ch = container.clientHeight;

      const ratio = Math.min(cw / this.imageW, ch / this.imageH);
      const zoom = (cw / ratio) * 0.9;

      this.ailabel = new AILabel.Map("AILabel-container", {
        center: { x: this.imageW / 2, y: this.imageH / 2 },
        zoom,
        withHotKeys: true
      });

      this.ailabel.setDrawingStyle({
        strokeStyle: "#409EFF",
        fillStyle: "#409EFF",
        lineWidth: 4
      });

      this.renderImageLayer();
      this.renderFeatureLayer();
      this.renderTextLayer();
      this.bindEvents();
    },

    renderImageLayer() {
      const layer = new AILabel.Layer.Image(
        "img-layer",
        {
          src: this.imageBlob,
          width: this.imageW,
          height: this.imageH
        },
        {},
        { zIndex: 5 }
      );

      layer.events.on("loadStart", () => (this.loading = true));
      layer.events.on("loadEnd", () => (this.loading = false));

      this.ailabel.addLayer(layer);
      this.imageLayer = layer;
    },

    renderFeatureLayer() {
      const layer = new AILabel.Layer.Feature(
        "feature-layer",
        {},
        { zIndex: 10 }
      );
      this.ailabel.addLayer(layer);
      this.featureLayer = layer;
    },

    renderTextLayer() {
      const layer = new AILabel.Layer.Text("text-layer", {}, { zIndex: 12 });
      this.ailabel.addLayer(layer);
      this.textLayer = layer;
    },
    // 判断点是否在标注图形内
    // 判断点是否在矩形内
    isPointInRect(point, rect) {
      const { x, y, width, height } = rect;
      return (
        point.x >= x &&
        point.x <= x + width &&
        point.y >= y &&
        point.y <= y + height
      );
    },
    isPointInFeature(point) {
      if (!point) return false;

      // 遍历所有图形
      for (const feature of this.labelList.reverse()) {
        const shape = feature.shape;

        let isIn = false;
        isIn = this.isPointInRect(point, shape);

        if (isIn) {
          return feature;
        }
      }

      return false;
    },
    bindEvents() {
      /** 绘制完成 */
      this.ailabel.events.on("drawDone", (type, data) => {
        if (
          data.x < 0 ||
          data.y < 0 ||
          data.x + data.width > this.imageW ||
          data.y + data.height > this.imageH
        ) {
          Message.warning("标注区域超出图片范围，请重新标注");
          return;
        }
        this.drawMark(data, this.labelValue);

        requestAnimationFrame(() => {
          this.onSetMode("PAN");
        });
      });

      /** 点击 */
      this.ailabel.events.on("click", e => {
        if (this.drawMode !== "PAN") {
          return;
        }
        const resData = this.isPointInFeature(e.global);
        this.popoverVisible = false;
        if (resData) {
          this.menuX = e.screen.x;
          this.menuY = e.screen.y;
          this.clickRegion = resData;
          requestAnimationFrame(() => {
            this.popoverVisible = true;
          });
        }
        // console.log(e);
        // if (this.drawMode !== "PAN") return;
        // const feature = this.getFeatureByPoint(e.global);
        // if (!feature) return;

        // this.clickRegion = feature;
        // this.menuX = e.screen.x;
        // this.menuY = e.screen.y;
        // this.popoverVisible = true;
      });
    },

    /** 设置模式 */
    onSetMode(mode) {
      this.drawMode = mode;
      this.ailabel.setMode(mode);
    },
    setOptions(data, label) {
      drawMark(data, label);
      this.$emit("input", this.labelList);
    },
    /** 创建标注 */
    drawMark(data, label) {
      console.log(data, label);
      const id = `${Date.now()}-${this.labelList.length}`;

      const rect = new AILabel.Feature.Rect(id, data, label, {
        strokeStyle: label.color,
        fillStyle: label.color,
        globalAlpha: 0.2,
        stroke: true,
        fill: true
      });

      this.featureLayer.addFeature(rect);

      const text = new AILabel.Text(
        id,
        {
          text: label.label,
          position: { x: data.x, y: data.y },
          offset: { x: 0, y: -26 }
        },
        label,
        {
          fillStyle: label.color,
          background: true,
          fontColor: "#ffffff",
          lineWidth: 0,
          strokeStyle: "transparent",
          font: "normal 20px Arial"
        }
      );

      this.textLayer.addText(text);

      this.labelList.push({
        id,
        shape: data,
        props: label
      });
      this.$emit("input", this.labelList);
    },

    /** 命中检测 */
    getFeatureByPoint(point) {
      return this.labelList.find(f => {
        const { x, y, width, height } = f.shape;
        return (
          point.x >= x &&
          point.x <= x + width &&
          point.y >= y &&
          point.y <= y + height
        );
      });
    },

    /** 删除 */
    deleteLabel() {
      const id = this.clickRegion.id;
      this.featureLayer.removeFeatureById(id);
      this.textLayer.removeTextById(id);
      this.labelList = this.labelList.filter(i => i.id !== id);
      this.popoverVisible = false;
      this.$emit("input", this.labelList);
      Message.success("删除成功");
    }
  }
};
</script>
<style scoped>
.image-label {
  height: 100%;
  display: flex;
  flex-direction: column;
  border: 1px solid #409eff;
}
#AILabel-container {
  flex: 1;
  border-top: 1px solid #409eff;
  position: relative;
  overflow: hidden;
  height: 100%;
}

.popover-anchor {
  position: absolute;
  width: 0;
  height: 0;
}

.menu-item {
  cursor: pointer;
  padding: 6px 10px;
}
.menu-item:hover {
  background: #f3f4f6;
}
.menu-item.danger {
  color: #ef4444;
}

.label-list {
  padding: 16px;
}
.label-item {
  padding: 8px;
  margin-bottom: 8px;
  color: #fff;
  border-radius: 4px;
  cursor: pointer;
}
.label-item.is-active {
  outline: 2px solid #409eff;
}
</style>



// WEBPACK FOOTER //
// src/components/ImageLabel.vue